export default __webpack_public_path__ + "2a7d8b6b560ef3982c0c83668a5fed53.gif";